<p-dialog 
  [header]="modalTitle" 
  [(visible)]="visible" 
  (visibleChange)="visibleChange.emit($event)"
  [modal]="true" 
  [style]="{width: '45vw'}" 
  [draggable]="false" 
  [resizable]="false"
  class="add-patient-modal">
  
  <form [formGroup]="patientForm" (ngSubmit)="onSubmit()">
    <div class="form-container">
      
      <!-- Basic Information -->
      <div class="form-section">
        <div class="row">
          <div class="col-6">
            <label for="firstName" class="form-label">First Name *</label>
            <input 
              pInputText 
              id="firstName"
              formControlName="firstName"
              class="form-input"
              placeholder="Enter first name">
          </div>
          <div class="col-6">
            <label for="lastName" class="form-label">Last Name *</label>
            <input 
              pInputText 
              id="lastName"
              formControlName="lastName"
              class="form-input"
              placeholder="Enter last name">
          </div>
        </div>
        
        <div class="row">
          <div class="col-6">
            <label for="dateOfBirth" class="form-label">Date of Birth</label>
            <input 
              pInputText 
              id="dateOfBirth"
              formControlName="dateOfBirth"
              type="date"
              class="form-input"
              placeholder="Select date">
          </div>
          <div class="col-6">
            <label for="sex" class="form-label">Sex</label>
            <p-select 
              id="sex"
              formControlName="sex"
              [options]="sexOptions"
              placeholder="Select sex"
              class="form-input">
            </p-select>
          </div>
        </div>
      </div>

      <!-- Contact Information -->
      <div class="form-section">
        <div class="row">
          <div class="col-6">
            <label for="phoneNumber" class="form-label">Phone Number</label>
            <input 
              pInputText 
              id="phoneNumber"
              formControlName="phoneNumber"
              class="form-input"
              placeholder="Enter phone number">
          </div>
          <div class="col-6">
            <label for="email" class="form-label">Email</label>
            <input 
              pInputText 
              id="email"
              formControlName="email"
              class="form-input"
              placeholder="Enter email address">
          </div>
        </div>
      </div>

      <!-- Address Information -->
      <div class="form-section">
        <div class="row">
          <div class="col-12">
            <label for="streetAddress" class="form-label">Street Address</label>
            <input 
              pInputText 
              id="streetAddress"
              formControlName="streetAddress"
              class="form-input"
              placeholder="Enter street address">
          </div>
        </div>
        <div class="row">
          <div class="col-4">
            <label for="city" class="form-label">City</label>
            <input 
              pInputText 
              id="city"
              formControlName="city"
              class="form-input"
              placeholder="Enter city">
          </div>
          <div class="col-4">
            <label for="state" class="form-label">State</label>
            <input 
              pInputText 
              id="state"
              formControlName="state"
              class="form-input"
              placeholder="Enter state">
          </div>
          <div class="col-4">
            <label for="zipCode" class="form-label">ZIP Code</label>
            <input 
              pInputText 
              id="zipCode"
              formControlName="zipCode"
              class="form-input"
              placeholder="Enter ZIP code">
          </div>
        </div>
      </div>

      <!-- Medical Information -->
      <div class="form-section">
        <h4 class="section-title">Medical Information</h4>
        <div class="row">
          <div class="col-12">
            <label for="allergies" class="form-label">Allergies</label>
            <textarea 
              pInputTextarea 
              id="allergies"
              formControlName="allergies"
              [rows]="2"
              class="form-input"
              placeholder="Enter any known allergies">
            </textarea>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <label for="primaryPhysician" class="form-label">Primary Physician</label>
            <input 
              pInputText 
              id="primaryPhysician"
              formControlName="primaryPhysician"
              class="form-input"
              placeholder="Enter physician name">
          </div>
          <div class="col-6">
            <label for="physicianContactNumber" class="form-label">Physician Contact Number</label>
            <input 
              pInputText 
              id="physicianContactNumber"
              formControlName="physicianContactNumber"
              class="form-input"
              placeholder="Enter 10-digit phone number">
          </div>
        </div>
      </div>

      <!-- Insurance Information -->
      <div class="form-section">
        <h4 class="section-title">Insurance Information</h4>
        <div class="row">
          <div class="col-6">
            <label for="insuranceName" class="form-label">Insurance Name</label>
            <input 
              pInputText 
              id="insuranceName"
              formControlName="insuranceName"
              class="form-input"
              placeholder="Enter insurance company name">
          </div>
          <div class="col-6">
            <label for="insurancePolicyNumber" class="form-label">Policy Number</label>
            <input 
              pInputText 
              id="insurancePolicyNumber"
              formControlName="insurancePolicyNumber"
              class="form-input"
              placeholder="Enter policy number">
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <label for="insurancePhone" class="form-label">Insurance Phone</label>
            <input 
              pInputText 
              id="insurancePhone"
              formControlName="insurancePhone"
              class="form-input"
              placeholder="Enter insurance phone number">
          </div>
        </div>
      </div>

      <!-- Patient Status (Edit Mode Only) -->
      <div class="form-section" *ngIf="mode === 'edit'">
        <h4 class="section-title">Patient Status</h4>
        <div class="row">
          <div class="col-12">
            <div class="checkbox-container">
              <input 
                type="checkbox"
                id="active"
                formControlName="active">
              <label for="active" class="checkbox-label">Patient is active</label>
            </div>
            <p class="checkbox-description" style="font-size: 12px !important; font-family: 'Inter', sans-serif !important;">Uncheck to deactivate this patient. Deactivated patients will not appear in patient lists.</p>
          </div>
        </div>
      </div>
    </div>
  </form>

  <ng-template pTemplate="footer">
    <div class="modal-footer">
      <p-button 
        label="Cancel" 
        severity="secondary" 
        [outlined]="true"
        (onClick)="onCancel()"
        class="cancel-btn">
      </p-button>
      <p-button 
        [label]="submitButtonLabel" 
        (onClick)="onSubmit()"
        [disabled]="!patientForm.valid || (mode === 'edit' && !hasChanges())"
        [class]="mode === 'edit' && hasChanges() ? 'add-btn has-changes' : 'add-btn'">
      </p-button>
    </div>
  </ng-template>
</p-dialog>
